import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { LayoutService } from '../../layout.service';
import { Subscription } from 'rxjs/Subscription';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  isHeroVisible: boolean;
  heroSubscription: Subscription;

  constructor(
              public authService: AuthService,
              private layoutService: LayoutService,
              private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {

    // subcribe to changes on the layoutservice's hero subscription
    this.heroSubscription = this.layoutService.heroItem
       .subscribe(item => this.isHeroVisible = item);
    
       // detect the changes in the set LayoutClasses
    // this.changeDetectorRef.detectChanges();

  }

  ngAfterViewInit() {

    // detect the changes in the set LayoutClasses
    this.changeDetectorRef.detectChanges();
    // execute the codebase js scripts
    Codebase.init();
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    this.heroSubscription.unsubscribe();
  }


  setLayoutClasses() {
    // console.log('Layout Component - hero is ' + this.isHeroVisible);
    return this.isHeroVisible ?
    // 'sidebar-mini sidebar-o sidebar-inverse side-scroll page-header-fixed main-content-boxed page-header-fixed page-header-glass' :
      'sidebar-mini sidebar-o sidebar-inverse side-scroll page-header-fixed main-content-boxed page-header-fixed page-header-glass' :
      'sidebar-mini sidebar-o sidebar-inverse side-scroll page-header-fixed main-content-boxed ';
  }
  // sidebar-o side-scroll page-header-fixed page-header-glass page-header-inverse main-content-boxed side-trans-enabled
}



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/layouts/normal/layout.component.ts